import { render, staticRenderFns } from "./documentList.vue?vue&type=template&id=65f5d321&scoped=true&"
import script from "./documentList.vue?vue&type=script&lang=js&"
export * from "./documentList.vue?vue&type=script&lang=js&"
import style0 from "./documentList.vue?vue&type=style&index=0&id=65f5d321&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f5d321",
  null
  
)

export default component.exports